import { useState, useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { filterPlansByQuery } from '@atlassian/jira-plans-main/src/services';
import { DEFAULT_PAGE_LIST } from '../../common/constants';
import type { Props, Plans, Fetch } from './types';

export default function FetchPlansService(props: Props) {
	const { status } = props;
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<Plans>(DEFAULT_PAGE_LIST);
	const [error, setError] = useState<boolean>(false);
	const [errorDetails, setErrorDetails] = useState<string | undefined>(undefined);

	const fetch: Fetch = useCallback(
		async (query) => {
			setLoading(true);
			try {
				const {
					isError,
					result,
					errorCode: permissionErrorCode,
				} = await filterPlansByQuery(query, status);

				if (isError) {
					setError(true);
					setErrorDetails(permissionErrorCode);
					setLoading(false);
					return;
				}
				if (result !== undefined) {
					setData(result);
				}
				setError(false);
				setErrorDetails(undefined);
				setLoading(false);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (err: any) {
				fireErrorAnalytics({
					meta: {
						id: 'FetchProjectsService',
						packageName: 'jiraInactivePlansDirectoryBase',
					},
					error: err,
					attributes: {
						status,
					},
				});
				setError(err);
				setLoading(false);
			}
		},
		[status],
	);

	return props.children({
		loading,
		error,
		data,
		fetch,
		errorDetails,
	});
}
